
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectdossierDocumentselectionEntryDto } from '../models/work-projectdossier-documentselection-entry-dto';

export function getCreateIndividualProjectdossierDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    documentselection: new FormControl<WorkProjectdossierDocumentselectionEntryDto[]>([]),
})
;
}
      